// extracted by mini-css-extract-plugin
export default {"trigger":"PopoverList_trigger__sMMBO","threeDotsBtn":"PopoverList_threeDotsBtn__W7Z4i","container":"PopoverList_container__o2VXy"};